import React from 'react';
import './LegalPage.css';

const TermsAndConditions = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">

        <div className="legal-header">
          <h1>Terms &amp; Conditions</h1>
          <p style={{ marginTop: '16px' }}>Last Updated: April 2026</p>
        </div>

        <div className="legal-notice">
          ⚠️ Please read these Terms carefully before using SwingSetupAI. By accessing or
          using our platform, you agree to be bound by these Terms. If you do not agree,
          please do not use the platform.
        </div>

        <div className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using SwingSetupAI ("Platform", "we", "our", "us"), you agree to be
            bound by these Terms and Conditions ("Terms"), along with all applicable laws and
            regulations of India. If you do not agree with these Terms, you must not access or
            use the Platform.
          </p>
        </div>

        <div className="legal-section">
          <h2>2. About the Platform</h2>
          <p>
            SwingSetupAI is a technical analysis and stock pattern screening platform provided
            strictly for educational and informational purposes.
          </p>
          <p>
            We are <strong>not registered with SEBI</strong> as an Investment Adviser, Research
            Analyst, or under any regulatory framework. Nothing on this Platform constitutes
            financial advice or recommendation.
          </p>
        </div>

        <div className="legal-section">
          <h2>3. Eligibility</h2>
          <p>By using the Platform, you represent and warrant that:</p>
          <ul>
            <li>You are at least 18 years of age</li>
            <li>You have the legal capacity to enter into a binding agreement</li>
            <li>You are accessing the Platform in compliance with applicable laws</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>4. User Account Responsibility</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account credentials
            and all activities under your account.
          </p>
          <p>You agree to:</p>
          <ul>
            <li>Provide accurate and complete information</li>
            <li>Not share your login credentials with others</li>
            <li>Notify us immediately of any unauthorized access</li>
          </ul>
          <p>We are not liable for any loss arising from unauthorized use of your account.</p>
        </div>

        <div className="legal-section">
          <h2>5. Subscription and Payments</h2>
          <ul>
            <li>Access to certain features requires a paid subscription</li>
            <li>Plans may be offered on a Monthly, Half-Yearly, or Yearly basis</li>
            <li>Payments are processed securely via third-party payment gateways</li>
            <li>Prices are inclusive of applicable taxes unless stated otherwise</li>
            <li>We reserve the right to modify pricing with prior notice</li>
          </ul>
          <p>Subscriptions are non-transferable and intended for single-user access only.</p>
        </div>

        <div className="legal-section">
          <h2>6. Permitted Use</h2>
          <p>
            You are granted a limited, non-exclusive, non-transferable license to use the Platform
            for personal, non-commercial, educational purposes only.
          </p>
          <p>You agree not to:</p>
          <ul>
            <li>Copy, reproduce, distribute, or resell any content or data</li>
            <li>Reverse engineer, decompile, or attempt to extract source code</li>
            <li>Use automated bots, scraping tools, or scripts</li>
            <li>Share or misuse access credentials</li>
            <li>Use the Platform to provide advisory or commercial services</li>
            <li>Attempt to breach or circumvent Platform security</li>
          </ul>
          <p>Violation of these Terms may result in immediate termination.</p>
        </div>

        <div className="legal-section">
          <h2>7. No Investment Advice</h2>
          <p>
            All content, including but not limited to screeners, charts, data, patterns, and
            analytics, is provided strictly for informational and educational purposes.
          </p>
          <p>Nothing on the Platform constitutes:</p>
          <ul>
            <li>Investment advice</li>
            <li>Financial recommendation</li>
            <li>Research analysis under SEBI regulations</li>
            <li>Any guarantee of returns or trading success</li>
          </ul>
          <p>
            All investment decisions are made solely at your own risk. You are strongly advised
            to consult a SEBI-registered investment adviser before making financial decisions.
          </p>
        </div>

        <div className="legal-section">
          <h2>8. Data Accuracy and Disclaimer</h2>
          <p>
            The data presented on the Platform may be sourced from third-party providers and
            processed using automated systems and algorithms.
          </p>
          <p>While we strive for accuracy, we do not guarantee that:</p>
          <ul>
            <li>Data is accurate, complete, or up-to-date</li>
            <li>Information is free from errors, delays, or omissions</li>
            <li>Results generated by the Platform are reliable</li>
          </ul>
          <p>You acknowledge that reliance on such data is entirely at your own risk.</p>
        </div>

        <div className="legal-section">
          <h2>9. No Warranties ("As-Is" Basis)</h2>
          <p>
            The Platform and all content are provided on an <strong>"as is" and "as available"
            basis</strong> without warranties of any kind, express or implied.
          </p>
          <p>We disclaim all warranties including, but not limited to:</p>
          <ul>
            <li>Merchantability</li>
            <li>Fitness for a particular purpose</li>
            <li>Accuracy and reliability of data</li>
            <li>Continuous availability or performance</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>10. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, SwingSetupAI and its operators shall not
            be liable for:
          </p>
          <ul>
            <li>Any trading or investment losses</li>
            <li>Financial or data loss</li>
            <li>Indirect, incidental, or consequential damages</li>
            <li>Loss of profits, revenue, or opportunities</li>
            <li>Errors, inaccuracies, or delays in data</li>
            <li>Platform downtime, interruptions, or security breaches</li>
          </ul>
          <p>
            Our total liability, if any, shall not exceed the subscription fees paid by you in
            the preceding 12 months.
          </p>
        </div>

        <div className="legal-section">
          <h2>11. Platform Availability and Risks</h2>
          <p>We do not guarantee uninterrupted or error-free access to the Platform.</p>
          <p>The Platform may be subject to:</p>
          <ul>
            <li>Downtime or maintenance</li>
            <li>Cyber-attacks, hacking, or unauthorized access</li>
            <li>Data corruption or loss</li>
            <li>Technical failures beyond our control</li>
          </ul>
          <p>Use of the Platform is at your own risk.</p>
        </div>

        <div className="legal-section">
          <h2>12. External Links</h2>
          <p>
            The Platform may contain links to third-party websites or services. We do not
            control or endorse such external websites and are not responsible for their content,
            accuracy, or practices. Accessing such links is at your own risk.
          </p>
        </div>

        <div className="legal-section">
          <h2>13. Intellectual Property</h2>
          <p>
            All content, including but not limited to algorithms, screeners, design, text,
            graphics, and software, is the intellectual property of SwingSetupAI. Unauthorized
            use, reproduction, or distribution is strictly prohibited.
          </p>
        </div>

        <div className="legal-section">
          <h2>14. Termination</h2>
          <p>
            We reserve the right to suspend or terminate your access to the Platform, without
            prior notice, if:
          </p>
          <ul>
            <li>You violate these Terms</li>
            <li>You engage in misuse or fraudulent activity</li>
            <li>Your actions pose risk to the Platform or other users</li>
          </ul>
          <p>Upon termination, your right to use the Platform ceases immediately.</p>
        </div>

        <div className="legal-section">
          <h2>15. Changes to Terms</h2>
          <p>
            We reserve the right to update or modify these Terms at any time. Material changes
            will be communicated via email or Platform notification. Continued use of the
            Platform constitutes acceptance of the revised Terms.
          </p>
        </div>

        <div className="legal-section">
          <h2>16. Governing Law and Dispute Resolution</h2>
          <p>These Terms shall be governed by the laws of India.</p>
          <p>
            Any disputes shall first be attempted to be resolved amicably. If unresolved,
            disputes shall be referred to arbitration under the Arbitration and Conciliation
            Act, 1996. The seat and venue of arbitration shall be <strong>Gujarat, India</strong>,
            and proceedings shall be conducted in English. Courts in India shall have exclusive
            jurisdiction.
          </p>
        </div>

        <div className="legal-section">
          <h2>17. Force Majeure</h2>
          <p>
            We shall not be held liable for any failure or delay in performance due to events
            beyond our reasonable control, including but not limited to natural disasters,
            government actions, internet failures, or technical disruptions.
          </p>
        </div>

        <div className="legal-section">
          <h2>18. Grievance Officer</h2>
          <p>
            In accordance with applicable laws, including the Information Technology Rules, 2021:
          </p>
          <div className="legal-contact-box">
            <p><strong>Grievance Officer — SwingSetupAI</strong></p>
            <p>
              Email:{' '}
              <a href="mailto:support@swingsetupai.com" className="legal-link">
                support@swingsetupai.com
              </a>
            </p>
            <p>
              We acknowledge complaints within <strong>24 hours</strong> and aim to resolve
              them within <strong>15 days</strong>.
            </p>
          </div>
        </div>

        <div className="legal-section">
          <h2>19. Contact</h2>
          <p>
            For any questions or concerns regarding these Terms, please contact us at:{' '}
            <a href="mailto:support@swingsetupai.com" className="legal-link">
              support@swingsetupai.com
            </a>
          </p>
        </div>

      </div>
    </div>
  );
};

export default TermsAndConditions;
